<template>
	<div>
		<div v-if="accountStatus === 0" class="no-account">
			<div class="bg">
			<div class="reason">暂未开通见证宝账户</div>
			<div class="can">开通见证宝账户，请与相关运营人员联系</div>
			</div>
		</div>
		<div class="account-frame" v-else :style="`height: ${iframeHeight}px`">
        	<iframe :src="frameUrl"  frameborder="0" width="100%" height="100%"></iframe>
    	</div>
	</div>
</template>
<script>
import dao from '@/lib/dao.js';
import bus from '@/lib/bus.js';

export default {
	data() {
		return {
			frameUrl: '',
			accountStatus: '',
			accountInfo: {},
			iframeHeight: document.documentElement.clientHeight - 60
		}
	},
	methods: {
		checkAccountStatus() {
			dao.shop.getAccountInfo().then(data => {
               	this.accountStatus = data;
              	this.accountStatus === 1 ? this.getStatus() : '';
            }).catch(msg => {
                this.$message.error(msg);
            });
		},
		getStatus() {
			dao.shop.getCompanyStatus().then(data => {
				this.accountInfo = data;
				this.makeUrl();
			}).catch(reason => this.$message.error(String(reason)));
		},
		makeUrl() {
			let params = this.accountInfo;
			params = encodeURIComponent(JSON.stringify(params));
			let current = window.location.href;
			let targetUrl = 'https://pay.bilibili.com/merchant-mis/#/auth/detail?params=';
			if (current.indexOf('jzbRedirectUrl') >= 0) {
				targetUrl = decodeURIComponent(current.split('=')[1]);
				this.frameUrl = targetUrl + '?params='+ params;
				return;
			}
			this.frameUrl = targetUrl + params;
		}
	},
	mounted() {
		document.domain = 'bilibili.com';
		dao.shop.getCompanyInfo().then(data => {
            bus.username = data;
            bus.smallAppName = bus.smallAppName;
            this.checkAccountStatus();
        }).catch(response => {
            if (response.code === 83001002) {
                this.logined = false;
            } else if (response.code !== 83001003) {
                this.$message.error(response.message);
            }
        });
	}
}
</script>
<style lang="less" scoped>
.no-account {
	padding: 20px;
	background: #fff;
	border: 1px solid #E0E5EC;
	min-height: 364px;
	font-size: 0;

	.bg {
		padding-top: 170px;
	    text-align: center;
	    font-size: 14px;
	    color: #5C667E;
	    background: url(./../../assets/nonactivated.png) center 0 no-repeat;
	    background-size: 168px 152px;

		.reason {
			font-size: 16px;
			font-weight: 500;
			color: #5C667E;
			margin-bottom: 7px;
		}
		.can {
			font-size: 14px;
			color: #99A2AA;
			
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/page/manage/PayCenter.vue